import { render, staticRenderFns } from "./VotationDetail.vue?vue&type=template&id=2baaba48&scoped=true&web=true&"
import script from "./VotationDetail.vue?vue&type=script&lang=js&"
export * from "./VotationDetail.vue?vue&type=script&lang=js&"
import style0 from "./VotationDetail.vue?vue&type=style&index=0&id=2baaba48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baaba48",
  null
  
)

export default component.exports